import { HTMLAttributes } from 'react'

import Grid from '@/components/base/grid'
import Media, { MediaElement } from '@/components/base/media'
import Section from '@/components/base/section'

import { cn } from '@/lib/utils'

export type SingleMediaProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    media: MediaElement
    aspect: 'landscape' | 'portrait'
    align: 'top' | 'center' | 'bottom'
    size: 'default' | 'big'
    use_overlay: boolean
  }>

const SingleMedia = ({
  media,
  aspect,
  align,
  use_overlay,
  className,
  size,
  ...props
}: SingleMediaProps) => {
  return (
    <Section className={cn('px-margin lg:px-0', className)} {...props}>
      <Grid>
        <div
          className={cn(
            'col-span-2 md:col-span-4 md:col-start-2',
            'lg:col-auto lg:row-span-8 lg:row-start-3',
            {
              'lg:w-[42rem]': aspect === 'portrait'
            },
            {
              'lg:grid lg:w-[42rem]': aspect === 'landscape'
            },
            {
              'lg:grid lg:aspect-video lg:w-auto':
                aspect === 'landscape' && size === 'big'
            },
            {
              'lg:items-start': align === 'top',
              'lg:items-center': align === 'center',
              'lg:items-end': align === 'bottom'
            }
          )}
        >
          <div
            className={cn('relative', {
              'lg:h-full lg:w-auto': aspect === 'portrait',
              'after:absolute after:left-0 after:top-0 after:h-full after:w-full after:bg-black/45':
                use_overlay
            })}
          >
            <Media
              fit="contain"
              className={cn('h-auto w-full', {
                'lg:h-full lg:w-auto': aspect === 'portrait',
                'lg:h-full lg:w-full': aspect === 'landscape'
              })}
              {...media}
            />
          </div>
        </div>
      </Grid>
    </Section>
  )
}

export default SingleMedia
